import { Quote } from '@/domain/stripe/quote/model/Quote'

export class QuoteWithMessage {
  constructor(
    public readonly message: string,
    public readonly quote: Quote,
  ) {
  }
}
